// import React, { useEffect, useState } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { routeConstants } from "../../constants/routeConstant";

// export default function DetailPageHeader() {
//   const [isMenuOpen, setIsMenuOpen] = useState(true);
//   const location = useLocation();

//   const menuItems = [
//     {
//       text: "HOME",
//       to: routeConstants.HOME,
//       icon: (
//         <svg
//           width="18"
//           fill="currentColor"
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 576 512"
//         >
//           <path d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"></path>
//         </svg>
//       ),
//       type: "link",
//     },
//     {
//       text: "ABOUT",
//       to: routeConstants.ABOUT_ME,
//       icon: (
//         <svg
//           class="text-accent1"
//           width="18"
//           fill="currentColor"
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 448 512"
//         >
//           <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0S96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"></path>
//         </svg>
//       ),
//       type: "link",
//     },
//     {
//       text: "SERVICES",
//       to: routeConstants.SERVICE_LIST,
//       icon: (
//         <svg
//           class="text-accent1"
//           width="18"
//           fill="currentColor"
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 512 512"
//         >
//           <path d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336c44.2 0 80-35.8 80-80s-35.8-80-80-80s-80 35.8-80 80s35.8 80 80 80z"></path>
//         </svg>
//       ),
//       type: "link",
//     },
//     {
//       text: "PORTFOLIO",
//       to: routeConstants.PORTFOLIO_LIST,
//       icon: (
//         <svg
//           class="text-accent1"
//           width="18"
//           fill="currentColor"
//           stroke="currentColor"
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 512 512"
//         >
//           <path d="M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"></path>
//         </svg>
//       ),
//       type: "link",
//     },
//     {
//       text: "ACHIEVEMENTS",
//       to: routeConstants.REWARD_CERTIFICATES,
//       icon: (
//         <svg
//           class="text-accent1"
//           width="18"
//           fill="currentColor"
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//         >
//           <path d="M18 2h-1V1a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v1H6a1 1 0 0 0-1 1v3a5 5 0 0 0 4.3 4.94A6.99 6.99 0 0 0 11 16.9V19H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.1a6.99 6.99 0 0 0 1.7-5.96A5 5 0 0 0 19 6V3a1 1 0 0 0-1-1zM7 6V4h1v2a3 3 0 0 1-3 3 3 3 0 0 1 2-3zm10 0a3 3 0 0 1-3 3V4h3v2z"></path>
//         </svg>
//       ),
//       type: "link",
//     },
//     // {
//     //   text: "BLOG",
//     //   to: "/blog",
//     //   icon: (
//     //     <svg
//     //       class="text-accent1"
//     //       width="18"
//     //       fill="currentColor"
//     //       stroke="currentColor"
//     //       xmlns="http://www.w3.org/2000/svg"
//     //       viewBox="0 0 448 512"
//     //     >
//     //       <path d="M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"></path>
//     //     </svg>
//     //   ),
//     //   type: "link",
//     // },
//     {
//       text: "CONTACT",
//       to: routeConstants.CONTACT_US,
//       icon: (
//         <svg
//           class="text-accent1"
//           width="18"
//           fill="currentColor"
//           stroke="currentColor"
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 512 512"
//         >
//           <path d="M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm96-96c0 35.3-28.7 64-64 64s-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"></path>
//         </svg>
//       ),
//       type: "link",
//       active: true,
//     },
//   ];

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 1024) {
//         // tablet & mobile
//         setIsMenuOpen(false);
//       } else {
//         setIsMenuOpen(true);
//       }
//     };

//     // Run on mount
//     handleResize();

//     // Also update when resizing
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return (
//     <div className={`toggle__navigation ${isMenuOpen ? "menu--visible" : ""}`}>
//       <button
//         className="toggle__navigation--button"
//         aria-label="Menu navigation"
//         onClick={() => setIsMenuOpen((prev) => !prev)}
//       >
//         {isMenuOpen ? (
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="28"
//             height="28"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             stroke-width="2"
//             stroke-linecap="round"
//             stroke-linejoin="round"
//             class="feather feather-x"
//           >
//             <line x1="18" y1="6" x2="6" y2="18"></line>
//             <line x1="6" y1="6" x2="18" y2="18"></line>
//           </svg>
//         ) : (
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="28"
//             height="28"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             stroke-width="2"
//             stroke-linecap="round"
//             stroke-linejoin="round"
//             class="feather feather-align-justify"
//           >
//             <line x1="21" y1="10" x2="3" y2="10"></line>
//             <line x1="21" y1="6" x2="3" y2="6"></line>
//             <line x1="21" y1="14" x2="3" y2="14"></line>
//             <line x1="21" y1="18" x2="3" y2="18"></line>
//           </svg>
//         )}
//       </button>

//       <ul className="toggle__nav--menu">
//         {menuItems.map((item, idx) => (
//           <li key={idx} className="toggle__nav--menu__items">
//             <Link
//               to={item.to}
//               className={`toggle__nav--menu__link ${
//                 location?.pathname === item.to ? "active" : ""
//               }`}
//               onClick={() => setIsMenuOpen(false)}
//             >
//               <span className="toggle__nav--menu__icon">{item.icon}</span>
//               <span className="toggle__nav--menu__text">{item.text}</span>
//             </Link>
//           </li>
//         ))}
//       </ul>

//       <span
//         className="toggle__navigation--bg"
//         onClick={() => setIsMenuOpen(false)}
//       ></span>
//     </div>
//   );
// }
import React from 'react'

export default function DetailPageHeader() {
  return (
    <>
      
    </>
  )
}
